import { SkipNavContent, SkipNavLink } from '@/components/core/SkipNavigation';
import React, { FC, useMemo } from 'react';

import Footer from '@/components/shared/footer';
import { Header } from '@/components/shared/headers/Header';
import PageHead from '@/components/shared/utillities/PageHead';
import NotificationStoreContext from '@/context/NotificationStoreContext';
import NotificationStore from '@/domain/notification/NotificationStore';

interface MainLayoutProps {
	title: string;
	children: React.ReactNode;
}

const MainLayout: FC = (props: MainLayoutProps) => {
	const { title, children } = props;
	const NotificationStoreInstance = useMemo(() => new NotificationStore(), []);

	return (
		<>
			<PageHead title={title} />

			<SkipNavLink targetId="main-content" />

			<NotificationStoreContext.Provider value={NotificationStoreInstance}>
				<Header />
			</NotificationStoreContext.Provider>

			<SkipNavContent id="main-content">
				<section className="content">{children}</section>
			</SkipNavContent>

			<SkipNavLink targetId="main-content" position='bottom' />

			<Footer />
		</>
	);
};

export default MainLayout;
